import { useState } from 'react';
import LangEnum from '../lang/LangEnum';
import { useTranslation } from '../modules/translation/TranslationContext';
import { restApi } from '../services/api';
import snackbarStore from '../stores/Snackbar.store';

const useImageUpload = (
  errorMessage: LangEnum = LangEnum.SNACKBAR_ERROR_LOADING_PROFILE_PICTURE,
) => {
  const { handleMessage } = snackbarStore;
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const { translate } = useTranslation();

  const uploadImage = async (file: File, size?: number): Promise<string> => {
    const formData = new FormData();
    formData.append('image', file as File);

    const params = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    setIsUploading(true);

    try {
      const response: any = await restApi.post(`/upload?width=${size || 512}`, formData, params);

      if (response.ok) {
        return response.data.url;
      }
    } finally {
      setIsUploading(false);
    }

    handleMessage({
      type: 'error',
      message: translate(errorMessage),
    });
    return '';
  };

  return {
    isUploading,
    uploadImage,
  };
};

export default useImageUpload;
